import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useMemo, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";

import { DjangoLegacyPaginationAdapter } from "api/common/adapters/pagination.adapters";
import { TableQueryParams } from "api/common/adapters/pagination.types";
import { createQueryAdapter } from "api/common/adapters/queryParam.adapter";
import { useExpandedEcrAssignmentQuery } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.api";
import ServerSidePaginatedDataGrid from "components/MUI/DataGrid/ServerSidePaginatedDataGrid";

import Filter from "./components/filters/Filter";
import { ExpandedEcrAssignmentReportColumns } from "./components/table/ExpandedEcrAssignmentReport.columns";
import ExpandedEcrToolbar from "./components/table/ExpandedEcrToolbar";
import "moment-timezone";

const expandedEcrApiAdapter = createQueryAdapter({
  paginationAdapter: DjangoLegacyPaginationAdapter,
});

const initialFilterState = {
  status: "Pre-Evaluation,Finalizing,In Assurance Maintenance,In Progress",
};

export default function ExpandedEcrAssignmentReport() {
  const [filterOpen, setFilterOpen] = useState(true);

  // SEE PINE TO EVALUATE FOR HOOK EXTRACTION OF THESE STATES/MEMOS
  const [sidebarFilters, setSidebarFilters] = useState(initialFilterState);
  const [tableParams, setTableParams] = useState<TableQueryParams>({
    page: 0,
    pageSize: 25,
    sort: { field: "v_id", direction: "desc" },
    search: "",
  });

  const expandedEcrQueryParams = useMemo(() => {
    return expandedEcrApiAdapter.toTableParams({
      filters: sidebarFilters,
      pagination: tableParams,
    });
  }, [sidebarFilters, tableParams]);

  const handleTableParamsChange = (queryParams: TableQueryParams) => {
    setTableParams(queryParams);
  };
  //

  const { data, isLoading } = useExpandedEcrAssignmentQuery(
    expandedEcrQueryParams,
  );

  if (isLoading) return null;

  const changeFilter = () => {
    setFilterOpen(!filterOpen);
  };

  // TODO: evaluate pattern in ProductsOverview.screen.tsx for standardization
  return (
    <>
      <Row className="mt-3 justify-content-end">
        <Col
          sm={12}
          md={2}
          className="d-flex justify-content-end align-content-center mb-2"
        >
          <Button
            variant="link rounded-pill"
            style={{
              backgroundColor: "#dedede",
              maxHeight: 40,
              display: "flex",
              justifyContent: "space-between",
            }}
            onClick={changeFilter}
          >
            {filterOpen ? (
              <>
                <KeyboardArrowRightIcon />
                <KeyboardArrowRightIcon />
                &nbsp; Close Filter &nbsp;
                <KeyboardArrowRightIcon />
                <KeyboardArrowRightIcon />
              </>
            ) : (
              <>
                <KeyboardArrowLeftIcon />
                <KeyboardArrowLeftIcon />
                &nbsp; Open Filter &nbsp;
                <KeyboardArrowLeftIcon />
                <KeyboardArrowLeftIcon />
              </>
            )}
          </Button>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={filterOpen ? 9 : 12}>
          <div style={{ height: "100%", width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ServerSidePaginatedDataGrid
                title="Expanded ECR Assignment Report"
                columns={ExpandedEcrAssignmentReportColumns}
                data={data}
                loading={isLoading}
                getRowId={(row) => row.v_id}
                tableParams={tableParams}
                onParamsChange={handleTableParamsChange}
                slots={{
                  toolbar: () => (
                    <ExpandedEcrToolbar
                      rowCount={data?.count || 0}
                      rows={data?.results || []}
                      sidebarFilters={sidebarFilters}
                      tableParams={tableParams}
                    />
                  ),
                }}
              />
            </div>
          </div>
        </Col>
        {filterOpen && (
          <Col xs={3}>
            <Filter filters={sidebarFilters} setFilters={setSidebarFilters} />
          </Col>
        )}
      </Row>
    </>
  );
}
